import { createApp } from 'vue';
import ItineraryOverviewApp from './ItineraryOverviewApp.vue';

// Only mounts when the mount point is present on the page.
const el = document.getElementById('itinerary-overview-app');
if (el) {
  createApp(ItineraryOverviewApp).mount('#itinerary-overview-app');
}
